// extracted by mini-css-extract-plugin
export default {"root":"ChallengesFilterForm_root__djE3G","formItem":"ChallengesFilterForm_formItem__zHAWO","label":"ChallengesFilterForm_label__Gp4wy"};